import apiFetch from '../apiFetch'

export default function (filtros, token) {    
  return apiFetch({endPoint: `Pool/cargaBatchUSA`,body:filtros, token, method: 'POST'})
}
